(function () {
  'use strict';
  var KB = window.SXC_KB;
  var root = document.querySelector('[data-sxc]');
  if (!KB || !root || root.__sxc) return;
  root.__sxc = 1;

  var cfg = {
    ai: (root.getAttribute('data-ai') || '').trim(),
    wa: (root.getAttribute('data-wa') || '917053754680').replace(/\D/g, ''),
    cat: root.getAttribute('data-cat') || '/?section_id=swapex-chat-catalog',
    teaser: root.getAttribute('data-teaser') || '',
    aiKb: root.getAttribute('data-ai-kb') || '',
    deviceAi: root.getAttribute('data-device-ai') === 'true'
  };
  if (/[?&]sxc_ai=1\b/.test(location.search)) ss('sxc-ai-dev', '1');
  var $ = function (s, el) { return (el || root).querySelector(s); };
  var fab = $('[data-sxc-fab]'), panel = $('[data-sxc-panel]'), log = $('[data-sxc-log]');
  var form = $('[data-sxc-form]'), input = $('[data-sxc-in]'), bar = $('[data-sxc-bar]');
  var teaser = $('[data-sxc-teaser]');
  var LOG_KEY = 'sxc-log-v1', OPEN_KEY = 'sxc-open', TEASE_KEY = 'sxc-teased';
  var lastQ = '', catalog = null, catalogP = null;

  /* ---------- helpers ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function waUrl(text) { return 'https://wa.me/' + cfg.wa + (text ? '?text=' + encodeURIComponent(text) : ''); }
  function genBy(k) { for (var i = 0; i < KB.gens.length; i++) if (KB.gens[i].k === k) return KB.gens[i]; return null; }
  var PART = { left: 'Left earbud', right: 'Right earbud', 'case': 'Charging case' };
  var ICON = {
    search: '<circle cx="11" cy="11" r="6"/><path d="M20 20l-4.2-4.2"/>',
    shield: '<path d="M12 3l7 3v5c0 4.5-3 8.3-7 10-4-1.7-7-5.5-7-10V6z"/><path d="M9 12l2 2 4-4"/>',
    truck: '<path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="18" r="1.6"/><circle cx="17" cy="18" r="1.6"/>',
    link: '<path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1"/><path d="M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1"/>',
    swap: '<path d="M4 8h13l-3-3M20 16H7l3 3"/>',
    chat: '<path d="M4 20l1.3-3.9A8 8 0 1 1 8 19.2z"/>',
    check: '<path d="M5 12l4 4 10-10"/>',
    pin: '<path d="M12 21s-6-5.3-6-10a6 6 0 1 1 12 0c0 4.7-6 10-6 10z"/><circle cx="12" cy="11" r="2"/>',
    layers: '<path d="M12 3l9 5-9 5-9-5z"/><path d="M3 13l9 5 9-5"/>',
    radar: '<circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="3"/>',
    card: '<rect x="3" y="6" width="18" height="12" rx="2"/><path d="M3 10h18"/>',
    x: '<path d="M6 6l12 12M18 6L6 18"/>',
    tag: '<path d="M3 12V4h8l10 10-8 8z"/><circle cx="7.5" cy="7.5" r="1.3"/>',
    tool: '<path d="M14 6a4 4 0 0 0 5 5l-8 8a2 2 0 0 1-3-3l8-8a4 4 0 0 1-2-2z"/>',
    alert: '<path d="M12 3l9 16H3z"/><path d="M12 10v4M12 17v.5"/>',
    bolt: '<path d="M13 3L5 13h6l-1 8 8-10h-6z"/>',
    box: '<path d="M3 7l9-4 9 4v10l-9 4-9-4z"/><path d="M3 7l9 4 9-4M12 11v10"/>'
  };
  function svg(name) { return '<svg viewBox="0 0 24 24" aria-hidden="true">' + (ICON[name] || ICON.chat) + '</svg>'; }

  /* ---------- rendering ---------- */
  function scroll() { requestAnimationFrame(function () { log.scrollTop = log.scrollHeight; }); }
  function persist() {
    var nodes = log.children, max = 40;
    while (nodes.length > max) log.removeChild(nodes[0]);
    var c = log.cloneNode(true);
    c.querySelectorAll('.sxc-m--typing').forEach(function (x) { x.remove(); });
    ss(LOG_KEY, c.innerHTML);
  }
  function add(html, who, extra) {
    var d = document.createElement('div');
    d.className = 'sxc-m sxc-m--' + who + (extra ? ' ' + extra : '');
    d.innerHTML = '<div class="sxc-b">' + html + '</div>';
    log.appendChild(d);
    persist(); scroll();
    return d;
  }
  function user(text) { add(esc(text), 'u'); }
  function chips(ids, cls) {
    return '<div class="sxc-chips' + (cls ? ' ' + cls : '') + '">' + ids.map(function (id) {
      var t = KB.topics[id]; if (!t) return '';
      return '<button type="button" class="sxc-chip" data-sxc-t="' + id + '">' + svg(t.icon) + '<span>' + esc(t.label) + '</span></button>';
    }).join('') + '</div>';
  }
  function act(list) {
    return '<div class="sxc-chips">' + list.map(function (c) {
      return '<button type="button" class="sxc-chip' + (c.cls ? ' ' + c.cls : '') + '" data-sxc-act="' + c.a + '"' +
        (c.g ? ' data-g="' + c.g + '"' : '') + (c.p ? ' data-p="' + c.p + '"' : '') + '>' + (c.icon ? svg(c.icon) : '') + '<span>' + esc(c.label) + '</span></button>';
    }).join('') + '</div>';
  }
  function waBtn(text, label) {
    return '<a class="sxc-wa" href="' + esc(waUrl(text)) + '" target="_blank" rel="noopener">' + svg('chat') + '<span>' + esc(label || 'Continue on WhatsApp') + '</span></a>';
  }
  function typing() {
    var d = document.createElement('div');
    d.className = 'sxc-m sxc-m--b sxc-m--typing';
    d.innerHTML = '<div class="sxc-typing" aria-label="Typing"><i></i><i></i><i></i></div>';
    log.appendChild(d); scroll();
    return d;
  }
  function reply(html, delay) {
    var t = typing();
    return new Promise(function (res) {
      setTimeout(function () { t.remove(); res(add(html, 'b')); }, delay == null ? 420 : delay);
    });
  }

  /* ---------- catalog (product links and stock from the store) ---------- */
  function loadCatalog() {
    if (catalog) return Promise.resolve(catalog);
    if (catalogP) return catalogP;
    catalogP = fetch(cfg.cat, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
      var m = html.match(/<script[^>]*data-sxc-cat[^>]*>([\s\S]*?)<\/script>/);
      catalog = m ? JSON.parse(m[1]) : [];
      return catalog;
    }).catch(function () { catalogP = null; return []; });
    return catalogP;
  }
  function vlabel(t) {
    return t.replace(/ANC \(Active Noise Cancellation\)/i, 'ANC').replace(/NON\s*-?\s*ANC/i, 'Non-ANC').replace(/TYPE-C/i, 'USB-C')
      .replace(/LIGHTNING/i, 'Lightning').replace(/Brand new/i, 'Brand New').replace(/\s*\/\s*/g, ' \u00b7 ');
  }
  /* ---------- price list (KB.prices) ---------- */
  var VARL = { NON: 'Non-ANC', ANC: 'ANC', 'TYPE-C': 'USB-C', LIGHTNING: 'Lightning' };
  function inr(n) { return '\u20b9' + Number(n).toLocaleString('en-IN'); }
  function priceRows(g, part, hint) {
    var rows = (KB.prices && KB.prices.rows) || [];
    var out = rows.filter(function (r) { return r.g === g && (!part || part === 'all' || r.p === part || (part === 'buds' && r.p !== 'case')); });
    var h = hint && hint.indexOf('NON') === 0 ? 'NON' : hint;
    if (h) { var f = out.filter(function (r) { return r.v === h; }); if (f.length) out = f; }
    return out;
  }
  function priceTable(g, part, hint) {
    var rows = priceRows(g, part, hint);
    if (!rows.length) return '';
    return '<div class="sxc-pt"><div class="sxc-pt__h"><span>Part</span><span>Brand New</span><span>Pre-Owned</span></div>' + rows.map(function (r) {
      return '<div class="sxc-pt__r"><span><b>' + PART[r.p] + '</b><small>' + (r.v ? VARL[r.v] + ' \u00b7 ' : '') + r.m + '</small></span><em>' + inr(r.n) + '</em><em>' + inr(r.u) + '</em></div>';
    }).join('') + '</div>';
  }
  function priceFor(g) {
    var gen = genBy(g);
    var tips = g.indexOf('pro') === 0 && KB.prices.tips ? '<p class="sxc-note">' + esc(KB.prices.tips.label) + ': <b>' + inr(KB.prices.tips.n) + '</b>.</p>' : '';
    return reply('<p><b>' + esc(gen.label) + '</b> price list:</p>' + priceTable(g) + tips +
      '<p class="sxc-note">' + KB.text.priceNote + '</p>' +
      act([{ a: 'fall', g: g, label: 'Shop ' + gen.label + ' parts' }, { a: 'topic-prices', label: 'Other AirPods', icon: 'tag', cls: 'sxc-chip--ghost' }]));
  }
  function cards(items, hint) {
    return '<div class="sxc-cards">' + items.map(function (p) {
      var rows = priceRows(p.g, p.p, hint);
      if (rows.length) {
        return '<a class="sxc-card' + (p.av ? '' : ' is-out') + '" href="' + esc(p.u) + '">' +
          '<span class="sxc-card__img">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy" width="72" height="72">' : '') + '</span>' +
          '<span class="sxc-card__t"><b>' + esc(p.t) + '</b>' +
          '<span class="sxc-card__v">' + rows.slice(0, 2).map(function (r) {
            return '<span class="sxc-pr"><small>' + (r.v ? VARL[r.v] + ' \u00b7 ' : '') + r.m + '</small>' +
              '<span><em>' + inr(r.n) + '</em> Brand New</span><span><em>' + inr(r.u) + '</em> Pre-Owned</span></span>';
          }).join('') + (p.av ? '' : '<small class="sxc-out">Currently sold out</small>') + '</span>' +
          '<span class="sxc-card__go">View & buy \u2192</span></span></a>';
      }
      var vs = p.v.filter(function (v) {
        var t = v.t.toUpperCase();
        return !hint || (t.indexOf(hint) > -1 && !(hint === 'ANC' && t.indexOf('NON') > -1));
      });
      if (!vs.length) vs = p.v;
      vs = vs.slice(0, 4);
      return '<a class="sxc-card' + (p.av ? '' : ' is-out') + '" href="' + esc(p.u) + '">' +
        '<span class="sxc-card__img">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy" width="72" height="72">' : '') + '</span>' +
        '<span class="sxc-card__t"><b>' + esc(p.t) + '</b>' +
        '<span class="sxc-card__v">' + vs.map(function (v) {
          var label = v.t === 'Default Title' ? 'Price' : vlabel(v.t);
          return '<span class="sxc-v' + (v.av ? '' : ' is-out') + '"><span>' + esc(label) + '</span>' +
            (v.av ? '<em>' + esc(v.pr.replace(/\.00$/, '')) + '</em>' : '<small>Sold out</small>') + '</span>';
        }).join('') + '</span>' +
        '<span class="sxc-card__go">View & buy \u2192</span></span></a>';
    }).join('') + '</div>';
  }
  function showParts(g, part, hint, intro) {
    var gen = genBy(g);
    var t = typing();
    return loadCatalog().then(function (list) {
      t.remove();
      var hits = list.filter(function (p) { return p.g === g && (!part || p.p === part || (part === 'buds' && p.p !== 'case')); });
      var order = { left: 0, right: 1, 'case': 2 };
      hits.sort(function (a, b) { return order[a.p] - order[b.p]; });
      var head = intro || ('Here\u2019s the <b>' + esc(gen ? gen.label : '') + (PART[part] ? ' ' + PART[part].toLowerCase() : part === 'buds' ? ' left & right earbuds' : ' parts') + '</b> we have right now:');
      if (!hits.length) {
        var col = gen ? (part === 'case' ? gen.ccol : gen.col) : '/collections/airpods';
        var pt = gen ? priceTable(g, part, hint) : '';
        part = PART[part] ? part : null;
        if (pt) {
          add('<p>' + head.replace(' we have right now:', ':') + '</p>' + pt + '<p class="sxc-note">' + KB.text.priceNote + '</p><p><a href="' + esc(col) + '">Shop these parts \u2192</a></p>', 'b');
          return;
        }
        add('<p>' + head + '</p><p>I couldn\u2019t load that listing just now. You can browse it here: <a href="' + esc(col) + '">see all \u2192</a></p>' +
          waBtn('Hi Swapex, do you have ' + (gen ? gen.label : 'AirPods') + ' ' + (part ? PART[part] : 'parts') + ' in stock?', 'Ask our team'), 'b');
        return;
      }
      var tip = g === 'pro2' && !hint ? '<p class="sxc-note">Pro 2 comes in <b>USB-C</b> and <b>Lightning</b> versions. Pick the option that matches your model number.</p>' : '';
      add('<p>' + head + '</p>' + cards(hits, hint) + tip + '<p class="sxc-note">' + KB.text.priceNote + '</p>' +
        chips(['conditions', 'warranty', 'pairing']), 'b');
    });
  }

  /* ---------- flows ---------- */
  function topic(id, quiet) {
    var t = KB.topics[id];
    if (!t) return;
    if (!quiet) user(t.label);
    if (t.flow === 'finder') {
      return reply('<p>Let\u2019s find your exact part. Which AirPods do you have?</p>' +
        act(KB.gens.map(function (g) { return { a: 'fgen', g: g.k, label: g.label }; }).concat([{ a: 'topic-modelhelp', label: 'Not sure', icon: 'tag', cls: 'sxc-chip--ghost' }])) +
        '<p class="sxc-note">Or just type your model number, like <b>A3048</b>.</p>');
    }
    if (t.flow === 'pairing') {
      return reply('<p>Which AirPods are you pairing?</p>' + act(KB.gens.map(function (g) { return { a: 'pgen', g: g.k, label: g.label }; })));
    }
    if (t.flow === 'fullset') {
      return reply('<p>No problem. We sell genuine Apple parts individually, so you can rebuild a complete set: <b>Left + Right + Charging case</b> of the same generation.</p>' +
        '<p>Which AirPods do you have?</p>' + act(KB.gens.map(function (g) { return { a: 'fall', g: g.k, label: g.label }; }).concat([{ a: 'topic-modelhelp', label: 'Not sure', icon: 'tag', cls: 'sxc-chip--ghost' }])));
    }
    if (t.flow === 'prices') {
      return reply('<p>Which AirPods do you have? I\u2019ll show the Brand New and Pre-Owned prices.</p>' +
        act(KB.gens.map(function (g) { return { a: 'prgen', g: g.k, label: g.label }; })) +
        '<p class="sxc-note">Or type your model number, like <b>A3048</b>.</p>');
    }
    if (t.flow === 'human') return human();
    var html = t.a;
    if (t.wa) html += waBtn(t.wa);
    if (t.next) html += chips(t.next);
    return reply(html);
  }
  function human() {
    var msg = 'Hi Swapex, ' + (lastQ ? 'I have a question: ' + lastQ : 'I need some help.');
    return reply('<p>' + KB.text.humanA + '</p>' + waBtn(msg, 'Chat with the team on WhatsApp') +
      '<p class="sxc-note">' + KB.text.humanTip + '</p><p><a href="/pages/contact-swapex">Other ways to reach us \u2192</a></p>');
  }
  function pairSteps(g) {
    var gen = genBy(g), r = KB.pairing[gen.reset];
    var html = '<p><b>Resetting ' + esc(gen.label) + '</b></p><ol class="sxc-steps">' + r.steps.map(function (s) { return '<li>' + s + '</li>'; }).join('') + '</ol>';
    if (r.note) html += '<p class="sxc-note">' + r.note + '</p>';
    html += '<p><a href="/pages/pairing-instructions">Full pairing guide with pictures \u2192</a></p>' + chips(['mismatch', 'findmy', 'human']);
    return reply(html, 520);
  }

  /* ---------- typed questions ---------- */
  function norm(s) { return (' ' + s.toLowerCase().replace(/[\u2019']/g, '').replace(/[^a-z0-9#\u20b9 ]+/g, ' ').replace(/\s+/g, ' ') + ' '); }
  function score(q) {
    var best = null, bs = 0;
    KB.intents.forEach(function (it) {
      var s = 0;
      for (var k in it.k) if (q.indexOf(' ' + k + ' ') > -1 || (k.length > 4 && q.indexOf(k) > -1)) s += it.k[k];
      if (s > bs) { bs = s; best = it.id; }
    });
    return { id: best, s: bs };
  }
  function parseGen(q) {
    if (/\bpro ?(3|3rd|third|iii)\b/.test(q)) return 'pro3';
    if (/\bpro ?(2|2nd|second|ii)\b/.test(q)) return 'pro2';
    if (/\bpro ?(1|1st|first)\b/.test(q) || /\bairpods? pro\b(?! ?\d)/.test(q)) return 'pro1';
    if (/\b(airpods? ?4|4th gen|gen ?4|airpod ?4)\b/.test(q)) return 'g4';
    if (/\b(airpods? ?3|3rd gen|gen ?3)\b/.test(q)) return 'g3';
    if (/\b(airpods? ?2|2nd gen|gen ?2)\b/.test(q)) return 'g2';
    return null;
  }
  function parsePart(q) {
    if (/\b(all|full set|complete set|whole set|everything|all three|all 3)\b/.test(q)) return 'all';
    if (/\bboth\b|\bdono\b|\bpair of\b/.test(q)) return 'buds';
    if (/\bleft\b|\bbaya\b|\bbayan\b/.test(q)) return 'left';
    if (/\bright\b|\bdaya\b|\bdayan\b/.test(q)) return 'right';
    if (/\bcase\b|\bcharging case\b|\bcharger case\b|\bdabba\b/.test(q)) return 'case';
    return null;
  }

  function handle(raw) {
    var text = raw.trim().slice(0, 500);
    if (!text) return;
    user(text);
    lastQ = text;
    var q = norm(text);

    var mm = text.toUpperCase().match(/\bA\s?(\d{4})\b/);
    if (mm) {
      var code = 'A' + mm[1], hit = KB.models[code];
      if (hit) {
        var gen = genBy(hit[0]);
        var what = gen.label + (hit[2] && hit[0] === 'pro2' ? (hit[2] === 'TYPE-C' ? ' (USB-C)' : ' (Lightning)') : '') + (hit[2] && hit[0] === 'g4' ? (hit[2] === 'ANC' ? ' with ANC' : ' (non-ANC)') : '');
        var hint = hit[2] === 'NON' ? 'NON' : hit[2];
        return showParts(hit[0], hit[1], hint, '<b>' + code + '</b> is the <b>' + esc(what) + (hit[1] ? ' ' + PART[hit[1]].toLowerCase() : '') + '</b>. ' + (hit[1] ? 'Here\u2019s the matching part:' : 'Which part do you need? Here\u2019s what fits:'));
      }
      return reply('<p><b>' + esc(code) + '</b> isn\u2019t in my quick list. Our team can check it for you in a minute.</p>' + waBtn('Hi Swapex, which part fits model ' + code + '?', 'Ask about ' + code) + chips(['modelhelp', 'finder']));
    }

    var on = text.match(/#\s?(\d{3,6})\b/) || (/\border\b/i.test(text) && text.match(/\b(\d{4,6})\b/));
    if (on) {
      return reply('<p>Thanks! For order <b>#' + esc(on[1]) + '</b>, our team will check the latest status and reply on WhatsApp.</p>' +
        waBtn('Hi Swapex, can you check my order #' + on[1] + '? ' + (text.length < 120 ? text : ''), 'Check order #' + on[1]) + chips(['shipping', 'cancel', 'exchange']));
    }

    for (var i = 0; i < KB.small.length; i++) if (KB.small[i].re.test(text) && text.length < 40) return reply('<p>' + KB.small[i].a + '</p>' + (i === 0 ? chips(KB.menu) : ''));

    var r = score(q), g = parseGen(q), p = parsePart(q);
    if (g && p === 'buds') return showParts(g, 'buds');
    if (g && (p === 'all' || r.id === 'fullset')) return showParts(g, null, null, 'Here\u2019s every <b>' + esc(genBy(g).label) + '</b> part we have. Pick the ones you need to complete your set:');
    if (g && p && (!r.id || r.id === 'finder' || r.id === 'fullset' || r.s < 4)) return showParts(g, p === 'all' ? null : p);

    var local = null;
    if (r.id && r.s >= 3) {
      local = function () {
        if (r.id === 'finder' && g) return showParts(g, p);
        if (r.id === 'pairing' && g) return pairSteps(g);
        if (r.id === 'prices' && g) return priceFor(g);
        return topic(r.id, true);
      };
    } else if (g) {
      local = function () {
        return reply('<p>Got it, <b>' + esc(genBy(g).label) + '</b>. What do you need?</p>' + act([
          { a: 'fpart', g: g, p: 'left', label: 'Left earbud' }, { a: 'fpart', g: g, p: 'right', label: 'Right earbud' },
          { a: 'fpart', g: g, p: 'case', label: 'Charging case' }, { a: 'pgen', g: g, label: 'Pairing help', icon: 'link', cls: 'sxc-chip--ghost' }]));
      };
    }
    // Short, clearly-matched questions get the prewritten answer instantly. Longer or unclear ones go to AI,
    // with the prewritten answer as the fallback if AI is unavailable, fails, or calls it out of scope.
    var words = q.trim().split(' ').length;
    if (local && (r.s >= 6 || words <= 6)) return local();
    return aiProvider().then(function (prov) {
      if (prov) return ask(text, prov, local);
      if (local) return local();
      if (/airpod|earbud|replac|case|part|need|buy/.test(q)) return topic('finder', true);
      return reply('<p>' + KB.text.noMatch + '</p>' + waBtn('Hi Swapex, ' + text) + chips(KB.menu.filter(function (x) { return x !== 'human'; })));
    });
  }

  /* ---------- AI fallback (server-side proxy; never holds the key here) ---------- */
  function history() {
    var out = [];
    log.querySelectorAll('.sxc-m').forEach(function (m) {
      var b = m.querySelector('.sxc-b'); if (!b) return;
      var t = b.cloneNode(true);
      t.querySelectorAll('.sxc-chips,.sxc-cards,.sxc-wa').forEach(function (x) { x.remove(); });
      var s = t.textContent.replace(/\s+/g, ' ').trim();
      if (s) out.push({ r: m.classList.contains('sxc-m--u') ? 'u' : 'b', t: s.slice(0, 600) });
    });
    return out.slice(-9, -1);
  }
  function fmt(s) {
    var lines = esc(s).replace(/\*\*(.+?)\*\*/g, '<b>$1</b>').split(/\n+/), html = '', list = '';
    lines.forEach(function (l) {
      var m = l.match(/^\s*(?:[-\u2022*]|\d+[.)])\s+(.*)/);
      if (m) { list += '<li>' + m[1] + '</li>'; return; }
      if (list) { html += '<ul>' + list + '</ul>'; list = ''; }
      if (l.trim()) html += '<p>' + l + '</p>';
    });
    if (list) html += '<ul>' + list + '</ul>';
    return html.replace(/(https:\/\/swapex\.in(?:\/[\w\-\/?=&.#]*)?)/g, '<a href="$1">$1</a>');
  }
  /* AI providers: 1) Swapex server (Gemini API, key kept server-side) 2) Chrome's built-in Gemini Nano on the
     visitor's device, only when the model is already installed (never triggers a multi-GB download for shoppers). */
  var NANO = { expectedInputs: [{ type: 'text', languages: ['en'] }], expectedOutputs: [{ type: 'text', languages: ['en'] }] };
  var provP = null, nanoBaseP = null, aiKbP = null;
  function aiProvider() {
    if (cfg.ai) return Promise.resolve('server');
    if (provP) return provP;
    var dev = ss('sxc-ai-dev') === '1';
    if (!(cfg.deviceAi || dev) || !cfg.aiKb || !('LanguageModel' in window)) return (provP = Promise.resolve(null));
    provP = Promise.resolve().then(function () { return window.LanguageModel.availability(NANO); }).then(function (a) {
      return a === 'available' || (dev && (a === 'downloadable' || a === 'downloading')) ? 'device' : null;
    }).catch(function () { return null; });
    return provP;
  }
  function loadAiKb() {
    if (window.SXC_AI) return Promise.resolve(window.SXC_AI);
    if (aiKbP) return aiKbP;
    aiKbP = new Promise(function (res, rej) {
      var sc = document.createElement('script');
      sc.src = cfg.aiKb; sc.async = true;
      sc.onload = function () { window.SXC_AI ? res(window.SXC_AI) : rej(new Error('kb')); };
      sc.onerror = function () { aiKbP = null; rej(new Error('kb')); };
      document.head.appendChild(sc);
    });
    return aiKbP;
  }
  function nanoBase(onProgress) {
    if (nanoBaseP) return nanoBaseP;
    nanoBaseP = loadAiKb().then(function (AI) {
      return window.LanguageModel.create(Object.assign({}, NANO, {
        initialPrompts: [{ role: 'system', content: AI.system }],
        monitor: function (m) { m.addEventListener('downloadprogress', function (e) { if (onProgress) onProgress(e.loaded); }); }
      }));
    }).then(function (sess) {
      if (sess.contextWindow && sess.contextUsage > sess.contextWindow * 0.9) throw new Error('context');
      return sess;
    });
    nanoBaseP.catch(function () { nanoBaseP = null; provP = Promise.resolve(null); });
    return nanoBaseP;
  }
  function askDevice(text, t) {
    var base, label = t.querySelector('.sxc-typing');
    return nanoBase(function (p) { if (label && p < 1) label.setAttribute('data-p', 'Getting the on-device assistant ready\u2026 ' + Math.round(p * 100) + '%'); })
      .then(function (b) { base = b; return b.clone ? b.clone() : b; })
      .then(function (sess) {
        var conv = history().slice(-4).map(function (m) { return (m.r === 'u' ? 'Customer: ' : 'Assistant: ') + m.t; }).join('\n');
        var prompt = (conv ? 'Conversation so far:\n' + conv + '\n\n' : '') + 'Customer question: ' + text;
        return sess.prompt(prompt, { responseConstraint: window.SXC_AI.schema }).then(function (out) {
          if (sess !== base && sess.destroy) try { sess.destroy(); } catch (e) {}
          return JSON.parse(out);
        });
      });
  }
  function askServer(text, signal) {
    return fetch(cfg.ai, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, signal: signal,
      body: JSON.stringify({ q: text, h: history(), p: location.pathname })
    }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
  }
  function sanitize(d) {
    if (!d || d.in_scope === false || typeof d.answer !== 'string' || !d.answer.trim()) return null;
    var a = d.answer.trim().slice(0, 1200).replace(/https?:\/\/[^\s)]+/g, function (u) {
      return /^https:\/\/(swapex\.in|wa\.me\/917053754680)(\/|\?|$)/.test(u) ? u : '';
    });
    var sug = (d.suggest || []).filter(function (id) { return KB.topics[id]; }).slice(0, 3);
    var ok = { '299': 1, '500': 1 };
    ((KB.prices && KB.prices.rows) || []).forEach(function (r) { ok[r.n] = 1; ok[r.u] = 1; });
    if (KB.prices && KB.prices.tips) ok[KB.prices.tips.n] = 1;
    var amounts = (a.match(/(?:\u20b9|rs\.?|inr)\s?[\d,]+/gi) || []).map(function (m) { return m.replace(/\D/g, ''); });
    if (amounts.some(function (x) { return !ok[x]; })) {
      a = 'Let me show you the exact price from our price list. Tap \u201cPrice list\u201d and pick your AirPods.';
      sug = ['prices', 'finder'];
    }
    return { answer: a, handoff: !!d.handoff, suggest: sug };
  }
  function ask(text, prov, local) {
    var t = typing(), ctl = window.AbortController ? new AbortController() : null, done = false;
    var timeout = new Promise(function (_, rej) { setTimeout(function () { if (!done) { if (ctl) ctl.abort(); rej(new Error('timeout')); } }, prov === 'device' ? 30000 : 20000); });
    var call = prov === 'device' ? askDevice(text, t) : askServer(text, ctl ? ctl.signal : undefined);
    return Promise.race([call, timeout]).then(function (raw) {
      done = true; t.remove();
      var d = sanitize(raw);
      if (!d) {
        if (local) return local();
        add('<p>' + KB.text.offTopic + '</p>' + chips(KB.menu), 'b');
        return;
      }
      add(fmt(d.answer) + (d.handoff ? waBtn('Hi Swapex, ' + text, 'Ask our team') : '') + (d.suggest.length ? chips(d.suggest) : '') +
        '<p class="sxc-ai">Answered by Swapex AI from our policies</p>', 'b', 'sxc-m--ai');
    }).catch(function () {
      done = true; t.remove();
      if (local) return local();
      add('<p>' + KB.text.aiError + '</p>' + waBtn('Hi Swapex, ' + text) + chips(['finder', 'pairing', 'warranty']), 'b');
    });
  }

  /* ---------- open / close ---------- */
  function welcome() {
    add('<p>' + KB.text.welcome + '</p><p class="sxc-note">' + KB.text.welcomeSub + '</p>' + chips(KB.menu, 'sxc-chips--menu'), 'b', 'sxc-m--hello');
  }
  function open(focus) {
    root.classList.add('is-open');
    fab.setAttribute('aria-expanded', 'true');
    panel.removeAttribute('hidden');
    hideTeaser(true);
    var fresh = !log.children.length;
    if (fresh) welcome();
    ss(OPEN_KEY, '1');
    document.documentElement.classList.add('sxc-lock');
    if (fresh) requestAnimationFrame(function () { log.scrollTop = 0; }); else scroll();
    if (focus !== false && window.matchMedia('(pointer:fine)').matches) setTimeout(function () { input.focus(); }, 180);
    loadCatalog();
  }
  function close() {
    root.classList.remove('is-open');
    fab.setAttribute('aria-expanded', 'false');
    ss(OPEN_KEY, null);
    document.documentElement.classList.remove('sxc-lock');
    setTimeout(function () { if (!root.classList.contains('is-open')) panel.setAttribute('hidden', ''); }, 260);
  }
  function hideTeaser(seen) {
    if (teaser) teaser.classList.remove('is-on');
    root.classList.remove('has-dot');
    if (seen) ss(TEASE_KEY, '1');
  }

  fab.addEventListener('click', function () { root.classList.contains('is-open') ? close() : open(); });
  root.addEventListener('click', function (e) {
    var el = e.target.closest('[data-sxc-t],[data-sxc-act],[data-sxc-close],[data-sxc-reset],[data-sxc-tease-open],[data-sxc-tease-x]');
    if (!el) return;
    if (el.hasAttribute('data-sxc-close')) return close();
    if (el.hasAttribute('data-sxc-tease-x')) { e.stopPropagation(); return hideTeaser(true); }
    if (el.hasAttribute('data-sxc-tease-open')) { open(); return topic('finder'); }
    if (el.hasAttribute('data-sxc-reset')) { log.innerHTML = ''; ss(LOG_KEY, null); lastQ = ''; welcome(); log.scrollTop = 0; return; }
    var id = el.getAttribute('data-sxc-t');
    if (id) return topic(id);
    var a = el.getAttribute('data-sxc-act'), g = el.getAttribute('data-g'), p = el.getAttribute('data-p');
    var label = el.textContent.trim();
    if (a.indexOf('topic-') === 0) return topic(a.slice(6));
    if (a === 'fgen') {
      user(label);
      return reply('<p>Which part of your <b>' + esc(genBy(g).label) + '</b> do you need?</p>' + act([
        { a: 'fpart', g: g, p: 'left', label: 'Left earbud' }, { a: 'fpart', g: g, p: 'right', label: 'Right earbud' }, { a: 'fpart', g: g, p: 'case', label: 'Charging case' }]));
    }
    if (a === 'fpart') { user(label); return showParts(g, p); }
    if (a === 'fall') { user(label); return showParts(g, null, null, 'Here\u2019s every <b>' + esc(genBy(g).label) + '</b> part we have. Pick the ones you need to complete your set:'); }
    if (a === 'pgen') { user(label); return pairSteps(g); }
    if (a === 'prgen') { user(label); return priceFor(g); }
  });
  bar.addEventListener('click', function (e) {
    var el = e.target.closest('[data-sxc-t]');
    if (el) topic(el.getAttribute('data-sxc-t'));
  });
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var v = input.value;
    if (!v.trim()) return;
    input.value = '';
    form.classList.remove('has-text');
    handle(v);
  });
  input.addEventListener('input', function () { form.classList.toggle('has-text', !!input.value.trim()); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) { close(); fab.focus(); } });
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-sxc-open],a[href="#swapex-chat"]');
    if (t) { e.preventDefault(); open(); var tp = t.getAttribute('data-sxc-open'); if (tp && KB.topics[tp]) topic(tp); }
  });
  window.SwapexChat = { open: open, close: close, ask: function (q) { open(); handle(q); } };

  /* ---------- restore + teaser ---------- */
  var saved = ss(LOG_KEY);
  if (saved) log.innerHTML = saved;
  bar.innerHTML = chips(KB.menu.concat(KB.more)).replace('class="sxc-chips"', 'class="sxc-chips sxc-chips--bar"');
  root.classList.add('is-ready');
  if (ss(OPEN_KEY) && window.innerWidth > 749) open(false);
  if (teaser && !ss(TEASE_KEY) && !ss(OPEN_KEY)) {
    setTimeout(function () {
      if (root.classList.contains('is-open') || ss(TEASE_KEY)) return;
      teaser.classList.add('is-on'); root.classList.add('has-dot');
      setTimeout(function () { teaser.classList.remove('is-on'); }, window.innerWidth < 750 ? 7000 : 12000);
    }, 9000);
  }
})();
